import { Route, Routes, Outlet } from 'react-router-dom'
import { ModelosListWrapper } from './modelos-list/ModelosList'
import { useT } from '_metronic/i18n/Metronici18n'
import { PageTitle } from '_metronic/layout/core'

const ModelosPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          index
          element={
            <>
              <PageTitle description={t('pagina.modelos.descricao')}>
                {t('modelo.plural')}
              </PageTitle>
              <ModelosListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ModelosPage
